import { axiosEduServer } from "../utils/configAxios";

export const registrarEntradaAsistencia = async (data) => {
  return axiosEduServer.post('/asistenciadocente/entrada', data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(({ data }) => data).catch((err) => { throw err });
};

export const registrarSalidaAsistencia = async (data) => {
  return axiosEduServer.put('/asistenciadocente/salida', data, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(({ data }) => data).catch((err) => { throw err });
};

export const getAsistenciasDocente = async (idDocente) => {
  return axiosEduServer.get(`/asistenciadocente/docente/${idDocente}`)
    .then(({ data }) => data).catch((err) => { throw err });
};

export const getAsistenciasAdmin = async () => {
  return axiosEduServer.get('/asistenciadocente/admin')
    .then(({ data }) => data).catch((err) => { throw err });
};

export const observarAsistenciaAdmin = async (data) => {
  return axiosEduServer.put('/asistenciadocente/admin/observar', data)
    .then(({ data }) => data).catch((err) => { throw err });
};
